import { Subject } from "rxjs";
import { Component } from "react";

class ConnectionState {
    public static none = 0;
    public static waiting = 1;
    public static active = 2;
    public static done = 3;
}

class AsyncSnapshot {
    private _connectionState;
    private _data;
    private _error?;
    private _hasData;
    private _hasError;

    constructor(connectionState: number, data?: any, error?: any) {
        this._connectionState = connectionState;
        this._data = data;
        this._error = error;
        this._hasData = !!data;
        this._hasError = !!error;
    }

    get connectionState() {
        return this._connectionState;
    }

    get data() {
        return this._data;
    }

    get error() {
        return this._error;
    }

    get hasData() {
        return this._hasData;
    }

    get hasError() {
        return this._hasError;
    }
}

export interface StreamBuilderProps {
    initialData: any;
    stream?: Subject<any>;
    builder: { (snapshot: AsyncSnapshot): any };
}

class StreamBuilder extends Component<StreamBuilderProps, any> {
    private snapshot: AsyncSnapshot = new AsyncSnapshot(ConnectionState.none);
    private subscription: any = null;
    // private stream
    constructor(props: StreamBuilderProps) {
        super(props);
        const { initialData, stream } = props;
        // this.stream =stream
        this.state = {
            /**
             * @type {AsyncSnapshot}
             */
            snapshot: new AsyncSnapshot(ConnectionState.waiting, initialData),
        };
        // if (stream) {
        //     stream.subscribe(
        //         data => {
        //
        //             this.setState({
        //                 snapshot: new AsyncSnapshot(ConnectionState.active, data, null),
        //             })
        //             ;
        //         },
        //         error => {
        //             if (error) {
        //                 this.setState({
        //                     snapshot: new AsyncSnapshot(ConnectionState.active, null, error),
        //                 });
        //             }
        //
        //         },
        //         () => {
        //             this.setState({
        //                 snapshot: new AsyncSnapshot(ConnectionState.done, null, null),
        //             });
        //         }
        //     );
        // }
    }
    componentDidMount() {
        if (this.props.stream && !this.subscription) {
            this.subscription = this.props.stream.subscribe(
                data => {
                    this.setState({
                        snapshot: new AsyncSnapshot(ConnectionState.active, data, null),
                    });
                },
                error => {
                    if (error) {
                        this.setState({
                            snapshot: new AsyncSnapshot(ConnectionState.active, null, error),
                        });
                    }
                },
                () => {
                    this.setState({
                        snapshot: new AsyncSnapshot(ConnectionState.done, null, null),
                    });
                }
            );
        }
    }

    componentDidUpdate(prevProps: Readonly<StreamBuilderProps>, prevState: Readonly<any>, snapshot?: any) {
        // Only resubscribe if the stream prop has changed
        if (this.props.stream !== prevProps.stream) {
            // Unsubscribe from the previous stream
            if (this.subscription) {
                this.subscription.unsubscribe();
                this.subscription = null;
            }

            // Subscribe to the new stream
            if (this.props.stream) {
                this.subscription = this.props.stream.subscribe(
                    data => {
                        this.setState({
                            snapshot: new AsyncSnapshot(ConnectionState.active, data, null),
                        });
                    },
                    error => {
                        if (error) {
                            this.setState({
                                snapshot: new AsyncSnapshot(ConnectionState.active, null, error),
                            });
                        }
                    },
                    () => {
                        this.setState({
                            snapshot: new AsyncSnapshot(ConnectionState.done, null, null),
                        });
                    }
                );
            }
        }
    }

    componentWillUnmount() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }

    render() {
        return this.props.builder(this.state.snapshot);
    }
}

export default StreamBuilder;
